import { useAuthService } from '../../services';

export default function () {
	return useAuthService().getAuthorizedOutletElement();
}